import React from 'react';
import { Box } from '@mui/material';

interface CalendarContainerProps {
  children: React.ReactNode;
  height?: string | number;
}

const CalendarContainer = React.forwardRef<HTMLDivElement, CalendarContainerProps>(
  ({ children, height = '100%' }, ref) => {
    return (
      <Box
        ref={ref}
        sx={{
          height,
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          borderRadius: 4,
          overflow: 'auto',
          position: 'relative',
        }}
      >
        {children}
      </Box>
    );
  },
);

CalendarContainer.displayName = 'CalendarContainer';

export default CalendarContainer;
